import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var AccessoriesRow = /*#__PURE__*/_styled("div", true ? {
  target: "e1hwwt3r0"
} : {
  target: "e1hwwt3r0",
  label: "AccessoriesRow"
})(true ? {
  name: "lyd1mn",
  styles: "display:flex;flex-wrap:wrap;align-items:center;gap:8px"
} : {
  name: "lyd1mn",
  styles: "display:flex;flex-wrap:wrap;align-items:center;gap:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvQ2FyZC9BY2Nlc3Nvcmllc1Jvdy9BY2Nlc3Nvcmllc1Jvdy52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFd0MiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9DYXJkL0FjY2Vzc29yaWVzUm93L0FjY2Vzc29yaWVzUm93LnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmV4cG9ydCBjb25zdCBBY2Nlc3Nvcmllc1JvdyA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiA4cHg7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});